// Tabs.tsx
import React, { useEffect, useState } from "react";
import AssetStatusForm from "../../AssetDetails/AssetDetailsForm/AssetStatusForm";
import AssetRunsForm from "../../AssetDetails/AssetDetailsForm/AssetRunsForm";
import { AssetAnalysis } from "../../AssetDetails/AssetAnalysis";
import { AssetAnalysisMobile } from "../../AssetDetailsMobileComponent/AssetAnalysisMobile";
import AssetStatusMobileForm from "../../AssetDetailsMobileComponent/AssetStatusMobile";
import AssetRunsMobileForm from "../../AssetDetailsMobileComponent/AssetRunsMobile";
import { useLocation, useNavigate } from "react-router-dom";
import { AssetAnalysisTablet } from "../../AssetDetailsMobileComponent/AssetStatusForms/Tablet/AssetAnalysisTablet";
import { AssetAnalysisForm } from "../../AssetDetails/AssetDetailsForm/AssetAnalysisForm";

interface Tab {
    badge: boolean;
    label: string;
    content: React.ReactNode;
    badgeValue?: number | undefined;
    Uri: string
}

type setStateCurrentTab = React.Dispatch<any>;
interface TabsProps {
    tabs: Tab[];
    runTableData: any[];
    chartsData: any[];
    assetName: string;
    assetId: string;
    customerId: string;
    handleLogout: () => void;
    index?: number;
    setStateCurrentTab: setStateCurrentTab;
    currentTab?: number;
    startTime?: string;
    endTime?: string
}

const AssetDetailsTabs: React.FC<TabsProps> = ({ tabs, runTableData, chartsData, assetName, assetId, customerId, handleLogout, index, setStateCurrentTab, currentTab, startTime, endTime }) => {
    const [activeTab, setActiveTab] = useState(index);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1300); // Assuming width less than 768px is considered mobile
    const location = useLocation();
    const navigate = useNavigate();
    const [wellVersion, setWellVersion] = useState("")
    const [auxProperties, setAuxProperties] = useState({
        aux1: { label: '', index: '', value: '', checked: false },
        aux2: { label: '', index: '', value: '', checked: false },
        aux3: { label: '', index: '', value: '', checked: false },
        mode: { label: '', index: '', value: '', checked: false },
        unit: { label: '', index: '', value: '', checked: false }
    });
    const [isIntermittentMode, setisIntermittentMode] = useState(false)
    const [isBasicWellMethod, setIsBasicWellMethod] = useState(false)
    // Store essential data in localStorage when props are available
    useEffect(() => {
        if (assetId && customerId && assetName) {
            localStorage.setItem('currentAssetData', JSON.stringify({
                assetId,
                customerId,
                assetName
            }));
        }
    }, [assetId, customerId, assetName]);

    // Fix the resize effect - remove window.innerWidth from dependency
    useEffect(() => {
        let timeoutId;

        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setIsMobile(window.innerWidth < 1300); // Update state based on window width             
            }, 100); // Adjust the debounce interval as needed
        };

        window.addEventListener('resize', handleResize); // Add event listener for window resize

        return () => {
            window.removeEventListener('resize', handleResize); // Remove event listener on component unmount
        };
    }, []); // Empty dependency array

    useEffect(() => {
        if (index) {
            setActiveTab(index)
        }

    }, [index])

    // Get values from props, location state, or localStorage as fallback
    const getResolvedValues = () => {
        // First try props and location state
        if (assetId && customerId) {
            return {
                resolvedAssetId: assetId,
                resolvedCustomerId: customerId,
                resolvedAssetName: assetName,
                resolvedStartTime: startTime || location.state?.startTime,
                resolvedEndTime: endTime || location.state?.endTime,
                resolvedCurrentTab: currentTab || location.state?.currentTab || 0
            };
        }

        // If props are missing (page refresh), try location state
        if (location.state?.assetId) {
            return {
                resolvedAssetId: location.state.assetId,
                resolvedCustomerId: location.state.customerId,
                resolvedAssetName: location.state.assetName,
                resolvedStartTime: location.state.startTime,
                resolvedEndTime: location.state.endTime,
                resolvedCurrentTab: location.state.currentTab || 0
            };
        }

        // Last resort: get from localStorage (for refresh scenarios)
        const savedData = localStorage.getItem('currentAssetData');
        if (savedData) {
            const parsed = JSON.parse(savedData);
            return {
                resolvedAssetId: parsed.assetId,
                resolvedCustomerId: parsed.customerId,
                resolvedAssetName: parsed.assetName,
                resolvedStartTime: location.state?.startTime,
                resolvedEndTime: location.state?.endTime,
                resolvedCurrentTab: location.state?.currentTab || 0
            };
        }

        return {
            resolvedAssetId: null,
            resolvedCustomerId: null,
            resolvedAssetName: null,
            resolvedStartTime: null,
            resolvedEndTime: null,
            resolvedCurrentTab: 0
        };
    };

    const {
        resolvedAssetId,
        resolvedCustomerId,
        resolvedAssetName,
        resolvedStartTime,
        resolvedEndTime,
        resolvedCurrentTab
    } = getResolvedValues();

    // NOW the early return can happen AFTER all hooks
    if (!resolvedAssetId || !resolvedCustomerId) {
        return <div>Loading asset details...</div>;
    }

    const onClickhandler = (index: number, uri: string) => {
        setActiveTab(index)
        setStateCurrentTab(index)
        // preserve query params (like ?assetId=...) when updating state
        navigate(`${location.pathname}${location.search}`, { replace: true, state: { assetId: resolvedAssetId, assetName: resolvedAssetName, customerId: resolvedCustomerId, currentTab: undefined } });
    }

    function getBrowserTimeZone() {

        // Get the timezone region
        var timeZoneRegion = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return timeZoneRegion;
    }

    var userTimeZone = getBrowserTimeZone();

    return (
        <div className="flex flex-col w-full">
            {/* Tab Content - USE RESOLVED VALUES HERE */}
            {<> {isMobile ? (<AssetStatusMobileForm assetName={resolvedAssetName} assetId={resolvedAssetId} customerId={resolvedCustomerId} userTimeZone={userTimeZone} handleLogout={handleLogout} setWellVersion={setWellVersion} setAuxProperties={setAuxProperties} setisIntermittentMode={setisIntermittentMode} setIsBasicWellMethod = {setIsBasicWellMethod} />) : (<AssetStatusForm assetName={resolvedAssetName} assetId={resolvedAssetId} customerId={resolvedCustomerId} userTimeZone={userTimeZone} handleLogout={handleLogout} setWellVersion={setWellVersion} setAuxProperties={setAuxProperties} setisIntermittentMode={setisIntermittentMode} setIsBasicWellMethod = {setIsBasicWellMethod} />)}
                {isMobile ? (<AssetRunsMobileForm assetName={resolvedAssetName} assetId={resolvedAssetId} customerId={resolvedCustomerId} userTimeZone={userTimeZone} handleLogout={handleLogout} wellVersion={wellVersion} />) : (<AssetRunsForm assetName={resolvedAssetName} assetId={resolvedAssetId} customerId={resolvedCustomerId} userTimeZone={userTimeZone} handleLogout={handleLogout} wellVersion={wellVersion} />)}
                {isMobile ? (<AssetAnalysisForm assetName={resolvedAssetName} assetId={resolvedAssetId} customerId={resolvedCustomerId} userTimeZone={userTimeZone} handleLogout={handleLogout} currentTab={resolvedCurrentTab} startTime={resolvedStartTime} endTime={resolvedEndTime} auxProperties={auxProperties} isIntermittentMode={isIntermittentMode} isBasicWellMethod={isBasicWellMethod} />) : (<AssetAnalysis assetName={resolvedAssetName} assetId={resolvedAssetId} customerId={resolvedCustomerId} userTimeZone={userTimeZone} handleLogout={handleLogout} currentTab={resolvedCurrentTab} startTime={resolvedStartTime} endTime={resolvedEndTime} auxProperties={auxProperties} isIntermittentMode={isIntermittentMode} isBasicWellMethod={isBasicWellMethod} />)}
            </>
            }
        </div>
    );
};

export default AssetDetailsTabs;
